var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "26px",
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pin-stop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 20 0 20 26 0 26"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin-stop"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fill: "#696969",
    stroke: "#fff",
    strokeWidth: 0.3,
    d: "M10.00171,0A10.072,10.072,0,0,0,0,10.1109c0,4.06177,2.42224,7.86639,4.75861,10.7016A36.84013,36.84013,0,0,0,9.4314,25.5379L10.00171,26l.57037-.4621a36.84215,36.84215,0,0,0,4.67273-4.7254C17.58118,17.97729,20,14.17267,20,10.1109A10.069,10.069,0,0,0,10.00171,0ZM10.016,14.77094c-6.44519,0-6.43457-10,0-10C16.46112,4.77094,16.4505,14.77094,10.016,14.77094Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinGray);
export default __webpack_public_path__ + "static/media/pin-gray.d166e6e8de64d12f64069a9fd0a73cc8.svg";
export { ForwardRef as ReactComponent };